export default {
  namespaced: true,
  state: {
    counter: 0,
  },
  getters: {
    get: (state) => {
      return state.counter
    },
  },
  mutations: {
    increment(state) {
      state.counter++
    },
    decrement(state) {
      if (state.counter > 0) {
        state.counter--
      }
    },
  },
  actions: {
    increment(context) {
      context.commit('increment')
    },
    decrement(context) {
      context.commit('decrement')
    },
  },
}
